import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import classes from "./PriceConfigurations.module.css";
import { AgGridReact } from "ag-grid-react";
import { ReactComponent as InfoIcon } from "../../assets/info-circle-filled.svg";
import { Button, Divider, Modal } from "antd";
import { ReactComponent as OrderBox } from "../../assets/order-box.svg";
import api from "../../utils/axios";
import { ColDef, RowValueChangedEvent } from "ag-grid-community";
import NumericEditor from "../../components/NumericEditor";
import { toast } from "react-toastify";
import ModalSelector from "../../components/form/ModalSelector";
import useLang from "../../hooks/useLang";
import DefaultSwitch from "../../components/form/DefaultSwitch";
import DefaultSelect from "../../components/form/DefaultSelect";
import { VALUE_BIG, VOLUME_BIG, WEIGHT_BIG } from "./PackageBIG";
import { VALUE_VIP, VOLUME_VIP, WEIGHT_VIP } from "./PackageVIP";
import {
	VALUE_SUPERVIP,
	VOLUME_SUPERVIP,
	WEIGHT_SUPERVIP,
} from "./PackageSUPERVIP";
import { VALUE_TREGU, VOLUME_TREGU, WEIGHT_TREGU } from "./PackageTREGU";
import { CONFIG } from "../../config";

type PackageValueDefaults = {
	id: number;
	from?: number;
	to?: number | null;
	percentage?: number;
	number?: number;
	zoneId: number;
};

type PackageWeightDefaults = {
	id: number;
	from?: number;
	to?: number | null;
	price?: number;
	number?: number;
	zoneId: number;
};
type PackagReturnValuesDefaults = {
	id: number;
	from?: number;
	to?: number | null;
	price?: number;
	percentage?: number;
	valueType?: number;
	number?: number;
	zoneId: number;
};
type OtherCountriesPackageDefaults = {
	countryId: number;
	country: string;
	packageWeightDefaults: PackageWeightDefaults[];
	packageValueDefaults: PackageValueDefaults[];
	packageVolumeDefaults: PackageWeightDefaults[];
	packageReturnValueDefaults: PackagReturnValuesDefaults[];
};
type Seller = {
	id: number;
	businessName?: string;
	businessNr?: string;
	firstName?: string;
	lastName?: string;
	username?: string;
	uniqueSellerIdentifier?: string;
};
const PriceConfigurations = () => {
	const [packageWeightColumns, setPackageWeightColumns] =
		useState<ColDef[]>();
	const [packageVolumeColumns, setPackageVolumeColumns] =
		useState<ColDef[]>();
	const [packageValueColumns, setPackageValueColumns] = useState<ColDef[]>();
	const [packageReturnValueColumns, setPackageReturnValueColumns] =
		useState<ColDef[]>();
	const [otherPackageWeightColumns, setOtherPackageWeightColumns] =
		useState<ColDef[]>();
	const [otherPackageVolumeColumns, setOtherPackageVolumeColumns] =
		useState<ColDef[]>();
	const [otherPackageValueColumns, setOtherPackageValueColumns] =
		useState<ColDef[]>();
	const [otherPackageReturnValueColumns, setOtherPackageReturnValueColumns] =
		useState<ColDef[]>();
	const [otherCountriesPackageDefaults, setOtherCountriesPackageDefaults] =
		useState<OtherCountriesPackageDefaults[]>();
	const [openModal, setOpenModal] = useState(false);
	const [packageWeightDefaults, setPackageWeightDefaults] = useState<
		PackageWeightDefaults[]
	>([]);
	const [packageValueDefaults, setPackageValueDefaults] = useState<
		PackageValueDefaults[]
	>([]);
	const [packageVolumeDefaults, setPackageVolumeDefaults] = useState<
		PackageWeightDefaults[]
	>([]);
	const [packageReturnValueDefaults, setPackageReturnValueDefaults] =
		useState<PackagReturnValuesDefaults[]>([]);

	const [editedWeightDefaults, setEditedWeightDefaults] = useState<
		PackageWeightDefaults[]
	>([]);
	const [editedVolumeDefaults, setEditedVolumeDefaults] = useState<
		PackageWeightDefaults[]
	>([]);
	const [editedValueDefaults, setEditedValueDefaults] = useState<
		PackageValueDefaults[]
	>([]);
	const [editedReturnValueDefaults, setEditedReturnValueDefaults] = useState<
		PackagReturnValuesDefaults[]
	>([]);

	const [configurationModalOpen, setConfigurationModalOpen] =
		useState<boolean>(false);
	const [packageBIG, setPackageBIG] = useState<boolean>(false);
	const [packageVIP, setPackageVIP] = useState<boolean>(false);
	const [packageSUPERVIP, setPackageSUPERVIP] = useState<boolean>(false);
	const [packageTREGU, setPackageTREGU] = useState<boolean>(false);

	const [sellers, setSellers] = useState<Seller[]>([]);
	const [selectedSeller, setSelectedSeller] = useState(null);

	const [seller, setSeller] = useState<Seller>();
	const [selectedSellerCredentials, setSelectedSellerCredentials] =
		useState<any>();
	const { strings } = useLang("priceConfiguration");

	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
			autoSizeAllColumns: true,
			autoHeaderHeight: true,
		}),
		[]
	);

	let grid = useRef(null);

	const getPackageWeightDefaults = async (seller?: Seller) => {
		try {
			const response = await api.get("packagedefaults/weight-list", {
				params: { sellerId: seller?.id },
			});
			setPackageWeightDefaults(response.data);
		} catch (error: any) {
			console.log(error);
		}
	};
	const getPackageValueDefaults = async (seller?: Seller) => {
		try {
			const response = await api.get("packagedefaults/value-list", {
				params: { sellerId: seller?.id },
			});
			setPackageValueDefaults(response.data);
		} catch (error: any) {
			console.log(error);
		}
	};
	const getPackageVolumeDefaults = async (seller?: Seller) => {
		try {
			const response = await api.get("packagedefaults/volume-list", {
				params: { sellerId: seller?.id },
			});
			setPackageVolumeDefaults(response.data);
		} catch (error: any) {
			console.log(error);
		}
	};
	const getReturnValueDefaults = async (seller?: Seller) => {
		try {
			const response = await api.get(
				"packagedefaults/return-value-list",
				{
					params: { sellerId: seller?.id },
				}
			);
			setPackageReturnValueDefaults(response.data);
		} catch (error: any) {
			console.log(error);
		}
	};

	const getOtherCountriesPackageDefaults = async (seller?: Seller) => {
		try {
			const response = await api.get(
				"packagedefaults/other-countries-list",
				{
					params: { sellerId: seller?.id },
				}
			);
			setOtherCountriesPackageDefaults(response.data);
		} catch (error: any) {
			console.log(error);
		}
	};
	const getSellers = async () => {
		try {
			const response = await api.get("user/sellers");
			setSellers(response.data);
		} catch (error: any) {
			console.log(error);
		}
	};
	const getPackageDefaults = async (seller?: Seller) => {
		await getPackageWeightDefaults(seller);
		await getPackageValueDefaults(seller);
		await getPackageVolumeDefaults(seller);
		await getReturnValueDefaults(seller);
		await getOtherCountriesPackageDefaults(seller);
	};

	useEffect(() => {
		getPackageDefaults();
	}, []);

	// useEffect(() => {
	// 	getOtherCountriesPackageDefaults();
	// }, []);

	useEffect(() => {
		getSellers();
	}, []);

	useEffect(() => {
		const packageDefaultColumns = [
			{
				field: "from",
				headerName: strings?.grid.from,
				width: 100,
			},
			{
				field: "to",
				headerName: strings?.grid.to,
				width: 100,
			},
		];
		const colsWithPrice = [
			...packageDefaultColumns,
			{
				field: "price",
				headerName: strings?.grid.price,
				width: 130,
				cellEditor: NumericEditor,
				cellEditorParams: {
					suffix: CONFIG?.CURRENCY,
				},
				cellStyle: {
					height: "100%",
				},
				editable: true,
			},
		];
		const colsWithPercentage = [
			...packageDefaultColumns,
			{
				field: "percentage",
				headerName: strings?.grid.percentage,
				cellEditor: NumericEditor,
				width: 130,
				cellEditorParams: {
					suffix: "%",
				},
				cellStyle: {
					height: "100%",
				},
				editable: true,
			},
		];
		const colsWithValue = [
			...packageDefaultColumns,
			{
				field: "price",
				headerName: strings?.grid.price,
				width: 130,
				cellEditor: NumericEditor,
				cellEditorParams: {
					suffix: CONFIG?.CURRENCY,
				},
				cellStyle: {
					height: "100%",
				},
				editable: (params: any) => params.data.valueType === 1,
			},
			{
				field: "percentage",
				headerName: strings?.grid.percentage,
				cellEditor: NumericEditor,
				width: 130,
				cellEditorParams: {
					suffix: "%",
				},
				cellStyle: {
					height: "100%",
				},
				editable: (params: any) => params.data.valueType === 2,
			},
		];
		const colsWithPriceAndPercentage = [
			...packageDefaultColumns,
			{
				field: "price",
				headerName: strings?.grid.price,
				width: 130,
				cellEditor: NumericEditor,
				cellEditorParams: {
					suffix: CONFIG?.CURRENCY,
				},
				cellStyle: {
					height: "100%",
				},
				editable: (params: any) => params.data.valueType === 1,
			},
			{
				field: "percentage",
				headerName: strings?.grid.percentage,
				cellEditor: NumericEditor,
				width: 130,
				cellEditorParams: {
					suffix: "%",
				},
				cellStyle: {
					height: "100%",
				},
				editable: (params: any) => params.data.valueType === 2,
			},
		];
		setOtherPackageVolumeColumns(colsWithPrice);
		setOtherPackageWeightColumns(colsWithPrice);
		setOtherPackageValueColumns(colsWithPercentage);
		setOtherPackageReturnValueColumns(colsWithValue);
		setPackageVolumeColumns(colsWithPrice);
		setPackageWeightColumns(colsWithPrice);
		setPackageValueColumns(colsWithPercentage);
		setPackageReturnValueColumns(colsWithPriceAndPercentage);
	}, [setPackageWeightColumns, strings]);

	const modalHandler = () => {
		setOpenModal(!openModal);
	};

	const updateArray = (prev: any[], data: any) => {
		if (prev.some((v) => v.id === data.id)) {
			return prev.map((v) => (v.id === data.id ? data : v));
		} else {
			return [...prev, data];
		}
	};

	const onVolumeRowValueChanged = (params: RowValueChangedEvent) => {
		setEditedVolumeDefaults((prev) => updateArray(prev, params.data));
	};
	const onWeightRowValueChanged = (params: RowValueChangedEvent) => {
		setEditedWeightDefaults((prev) => updateArray(prev, params.data));
	};
	const onValueRowValueChanged = (params: RowValueChangedEvent) => {
		setEditedValueDefaults((prev) => updateArray(prev, params.data));
	};
	const onReturnValueRowValueChanged = (params: RowValueChangedEvent) => {
		setEditedReturnValueDefaults((prev) => updateArray(prev, params.data));
	};

	const onSubmit = async () => {
		try {
			await api.post("packagedefaults/update", {
				valueDefaults: editedValueDefaults.map((v) => ({
					id: v.id,
					percentage: v.percentage,
					number: v.number,
					zoneId: v.zoneId,
				})),
				weightDefaults: editedWeightDefaults.map((v) => ({
					id: v.id,
					price: v.price,
					number: v.number,
					zoneId: v.zoneId,
				})),
				volumeDefaults: editedVolumeDefaults.map((v) => ({
					id: v.id,
					price: v.price,
					number: v.number,
					zoneId: v.zoneId,
				})),
				returnValueDefaults: editedReturnValueDefaults.map((v) => ({
					id: v.id,
					price: v.price,
					percentage: v.percentage,
					number: v.number,
					zoneId: v.zoneId,
				})),
				sellerId: seller?.id,
			});
			setEditedValueDefaults([]);
			setEditedVolumeDefaults([]);
			setEditedWeightDefaults([]);
			setEditedReturnValueDefaults([]);
			toast.success(strings?.toast.success);
			await getPackageDefaults(seller);
		} catch (e) {
			console.log(e);
		}
	};

	const onSellerSelected = async (row: Seller) => {
		setSeller(row);
		await getPackageDefaults(row);
	};

	const onSellerDeleted = async () => {
		setSeller(undefined);
		setEditedValueDefaults([]);
		setEditedVolumeDefaults([]);
		setEditedWeightDefaults([]);
		setEditedReturnValueDefaults([]);
		await getPackageDefaults();
		await getOtherCountriesPackageDefaults();
	};

	const renderSellerOptions = () => {
		return sellers.map((sellerItem: Seller, index: number) => ({
			value: `${sellerItem.id}-${index}`,
			label: `${sellerItem.username}  (${
				sellerItem.uniqueSellerIdentifier ?? ""
			})`,
		}));
	};

	const [selectedPackageString, setSelectedPackageString] = useState("");
	const changeSwitch = (selectedPackage: string) => {
		setPackageBIG(selectedPackage === "BIG");
		setPackageVIP(selectedPackage === "VIP");
		setPackageSUPERVIP(selectedPackage === "SUPERVIP");
		setPackageTREGU(selectedPackage === "TREGU");
		switch (selectedPackage) {
			case "BIG":
			case "VIP":
			case "SUPERVIP":
			case "TREGU":
				setSelectedPackageString(selectedPackage);
				break;
			default:
				setSelectedPackageString("");
		}
	};
	const updateConfirgurationsPerSellerAndPackage = async () => {
		const packageDefaults: any = {
			BIG: {
				value: VALUE_BIG,
				volume: VOLUME_BIG,
				weight: WEIGHT_BIG,
			},
			VIP: {
				value: VALUE_VIP,
				volume: VOLUME_VIP,
				weight: WEIGHT_VIP,
			},
			SUPERVIP: {
				value: VALUE_SUPERVIP,
				volume: VOLUME_SUPERVIP,
				weight: WEIGHT_SUPERVIP,
			},
			TREGU: {
				value: VALUE_TREGU,
				volume: VOLUME_TREGU,
				weight: WEIGHT_TREGU,
			},
		};

		if (packageDefaults[selectedPackageString]) {
			const packageData = packageDefaults[selectedPackageString];
			const value = packageData.value;
			const volume = packageData.volume;
			const weight = packageData.weight;

			try {
				await api.post("packagedefaults/update-packages", {
					valueDefaults: value.map((v: any) => ({
						id: v.id,
						percentage: v.percentage,
						number: v.number,
						zoneId: v.zoneId,
					})),
					weightDefaults: weight.map((v: any) => ({
						id: v.id,
						price: v.price,
						number: v.number,
						zoneId: v.zoneId,
					})),
					volumeDefaults: volume.map((v: any) => ({
						id: v.id,
						price: v.price,
						number: v.number,
						zoneId: v.zoneId,
					})),
					sellerIds: selectedSeller,
				});
				setEditedValueDefaults([]);
				setEditedVolumeDefaults([]);
				setEditedWeightDefaults([]);
				setEditedReturnValueDefaults([]);
				setSelectedSeller(null);
				toast.success(strings?.toast.success);
				await getPackageDefaults(seller);
				setConfigurationModalOpen(false);
			} catch (e) {
				console.log(e);
			}
		}
	};

	const clearModalConfigurationStates = () => {
		setEditedValueDefaults([]);
		setEditedVolumeDefaults([]);
		setEditedWeightDefaults([]);
		setEditedReturnValueDefaults([]);
		setPackageBIG(false);
		setPackageVIP(false);
		setPackageSUPERVIP(false);
		setPackageTREGU(false);
		setSelectedSeller(null);
		setConfigurationModalOpen(false);
	};

	const onSellerForPackageSelected = (sellerIds: any) => {
		const filteredSellerIds = sellerIds?.map((id: any) => id.split("-")[0]);
		setSelectedSeller(filteredSellerIds);
		setSelectedSellerCredentials(sellerIds);
	};

	return (
		<>
			<div className={classes.mainContainer}>
				<h1 className={classes.title}>{strings?.titles.main}</h1>
				<div>
					<ModalSelector
						buttonLabel={strings?.button.seller}
						tableData={sellers}
						onRowSelected={onSellerSelected}
						onRowDeleted={onSellerDeleted}
						columnsToShow={["firstName", "lastName"]}
					/>
				</div>

				<div className="flex w-full">
					<Button
						className="button2"
						onClick={() => setConfigurationModalOpen(true)}
					>
						Paketat
					</Button>
				</div>

				<div className={classes.firstContainer}>
					<div className="w-full">
						<div className={classes.packageTitle}>
							{strings?.titles.volume}
						</div>
						<div
							className="ag-theme-alpine"
							style={{
								width: "80%",
								height: 400,
							}}
						>
							<AgGridReact
								rowData={packageVolumeDefaults}
								columnDefs={packageVolumeColumns}
								defaultColDef={defaultColDef}
								defaultExcelExportParams={
									defaultExcelExportSettings
								}
								ref={grid}
								editType={"fullRow"}
								rowHeight={40}
								onRowValueChanged={onVolumeRowValueChanged}
							/>
						</div>
					</div>
					<div className="w-full">
						<div className={classes.packageTitle}>
							{strings?.titles.weight}
						</div>
						<div
							className="ag-theme-alpine"
							style={{
								width: "80%",
								height: 400,
							}}
						>
							<AgGridReact
								rowData={packageWeightDefaults}
								columnDefs={packageWeightColumns}
								defaultColDef={defaultColDef}
								suppressCopyRowsToClipboard={true}
								defaultExcelExportParams={
									defaultExcelExportSettings
								}
								ref={grid}
								editType={"fullRow"}
								rowHeight={40}
								onRowValueChanged={onWeightRowValueChanged}
							/>
						</div>
					</div>
					<div className="w-full">
						<div className={classes.packageTitle}>
							{strings?.titles.value}
						</div>
						<div
							className="ag-theme-alpine"
							style={{
								width: "80%",
								height: 400,
							}}
						>
							<AgGridReact
								rowData={packageValueDefaults}
								columnDefs={packageValueColumns}
								defaultColDef={defaultColDef}
								defaultExcelExportParams={
									defaultExcelExportSettings
								}
								editType={"fullRow"}
								ref={grid}
								rowHeight={40}
								onRowValueChanged={onValueRowValueChanged}
							/>
						</div>
					</div>
					<div className="w-full">
						<div className={classes.packageTitle}>
							{strings?.titles.returnValue}
						</div>
						<div
							className="ag-theme-alpine"
							style={{
								width: "80%",
								height: 400,
							}}
						>
							<AgGridReact
								rowData={packageReturnValueDefaults}
								columnDefs={packageReturnValueColumns}
								defaultColDef={defaultColDef}
								defaultExcelExportParams={
									defaultExcelExportSettings
								}
								editType={"fullRow"}
								ref={grid}
								rowHeight={40}
								onRowValueChanged={onReturnValueRowValueChanged}
							/>
						</div>
					</div>
				</div>

				<div className={classes.secondContainer}>
					<InfoIcon />
					<div>
						<p className={classes.secondTitle}>
							{strings?.info.dimension}
						</p>
						<p className={classes.info}>
							{strings?.info.clickForMore}
						</p>
					</div>
				</div>
				<div className={classes.thirdContainer}>
					<h1 className={classes.title}>
						{strings?.titles.countryConfig}
					</h1>
					<div>
						{otherCountriesPackageDefaults?.map((opd, key) => {
							return (
								<div
									className={classes.otherCountries}
									key={key}
								>
									<div className={classes.country}>
										{opd.country}
									</div>

									<div
										className={`${classes.firstContainer} ${classes.otherGridContainer}`}
									>
										<div className="w-full">
											<div
												className={classes.packageTitle}
											>
												{strings?.titles.volume}
											</div>
											<div
												className="ag-theme-alpine"
												style={{
													width: "100%",
													height: 300,
												}}
											>
												<AgGridReact
													rowData={
														opd.packageVolumeDefaults
													}
													columnDefs={
														otherPackageVolumeColumns
													}
													defaultColDef={
														defaultColDef
													}
													defaultExcelExportParams={
														defaultExcelExportSettings
													}
													ref={grid}
													editType={"fullRow"}
													rowHeight={40}
													onRowValueChanged={
														onVolumeRowValueChanged
													}
												/>
											</div>
										</div>
										<div className="w-full">
											<div
												className={classes.packageTitle}
											>
												{strings?.titles.weight}
											</div>
											<div
												className="ag-theme-alpine"
												style={{
													width: "100%",
													height: 300,
												}}
											>
												<AgGridReact
													rowData={
														opd.packageWeightDefaults
													}
													columnDefs={
														otherPackageWeightColumns
													}
													defaultColDef={
														defaultColDef
													}
													suppressCopyRowsToClipboard={
														true
													}
													defaultExcelExportParams={
														defaultExcelExportSettings
													}
													ref={grid}
													editType={"fullRow"}
													rowHeight={40}
													onRowValueChanged={
														onWeightRowValueChanged
													}
												/>
											</div>
										</div>
										<div className="w-full">
											<div
												className={classes.packageTitle}
											>
												{strings?.titles.value}
											</div>
											<div
												className="ag-theme-alpine"
												style={{
													width: "100%",
													height: 300,
												}}
											>
												<AgGridReact
													rowData={
														opd.packageValueDefaults
													}
													columnDefs={
														otherPackageValueColumns
													}
													defaultColDef={
														defaultColDef
													}
													defaultExcelExportParams={
														defaultExcelExportSettings
													}
													editType={"fullRow"}
													ref={grid}
													rowHeight={40}
													onRowValueChanged={
														onValueRowValueChanged
													}
												/>
											</div>
										</div>
										<div className="w-full">
											<div
												className={classes.packageTitle}
											>
												{strings?.titles.returnValue}
											</div>
											<div
												className="ag-theme-alpine"
												style={{
													width: "100%",
													height: 300,
												}}
											>
												<AgGridReact
													rowData={
														opd.packageReturnValueDefaults
													}
													columnDefs={
														otherPackageReturnValueColumns
													}
													defaultColDef={
														defaultColDef
													}
													defaultExcelExportParams={
														defaultExcelExportSettings
													}
													ref={grid}
													editType={"fullRow"}
													rowHeight={40}
													onRowValueChanged={
														onReturnValueRowValueChanged
													}
												/>
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<div className="flex justify-end">
				<Button
					type="primary"
					size="large"
					// className="bg-blue-700"
					style={{ backgroundColor: "#4F16C2" }}
					onClick={onSubmit}
				>
					{strings?.button?.save}
				</Button>
			</div>
			<Modal
				open={openModal}
				onCancel={() => setOpenModal(false)}
				centered
				footer={null}
			>
				<p className={classes.modalTitle}>{strings?.modal?.title}</p>
				<div className={classes.modal}>
					<OrderBox />
				</div>
			</Modal>
			<Modal
				open={configurationModalOpen}
				onCancel={clearModalConfigurationStates}
				onOk={updateConfirgurationsPerSellerAndPackage}
				title={"Ndrysho paketen per klient"}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
				okText="Ne rregull"
				cancelText="Mbyll"
				width={800}
			>
				<Divider />
				<div className="flex flex-col justify-around  gap-8 pl-6">
					<div className="flex w-full">
						<DefaultSelect
							label={"Shitesi"}
							flexDirection="col"
							alignCenter="start"
							className={"registerInput"}
							placeholder={"Zgjedh Shitesin"}
							options={renderSellerOptions()}
							value={selectedSellerCredentials ?? undefined}
							onChange={onSellerForPackageSelected}
							allowClear
							mode="multiple"
						/>
					</div>
					<div className="flex flex-col gap-4 ">
						<p className="">Paketat</p>

						<div className="flex flex-row  items-center gap-4">
							<DefaultSwitch
								label={"Paketa BIG"}
								checked={packageBIG}
								onChange={() => changeSwitch("BIG")}
							/>
							<DefaultSwitch
								label={"Paketa VIP"}
								checked={packageVIP}
								onChange={() => changeSwitch("VIP")}
							/>
							<DefaultSwitch
								label={"Paketa SUPER VIP"}
								checked={packageSUPERVIP}
								onChange={() => changeSwitch("SUPERVIP")}
							/>
							<DefaultSwitch
								label={"Paketa TREGU"}
								checked={packageTREGU}
								onChange={() => changeSwitch("TREGU")}
							/>
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default PriceConfigurations;
